const primary = "#3054A1";
const black = "#000000";
const white = "#FFFFFF";
const lightGrey1 = "#F6F6F6";
const lightGrey2 = "#F2F4FA";
const lightGrey3 = "#D6D6D6";
const lightGrey4 = "#8C8C8C";
const lightGrey5 = "#696969";
const lightGrey6 = "#D8D8D8";
const lightGrey7 = "#B0B0B0";
const lightGrey8 = "#767676";
const lightGrey9 = "#F9FAFD";
const lightGrey10 = "#555555";
const lightGrey11 = "#CFCFCF";
const lightGrey12 = "#8A8A8A";
const darkGrey1 = "#333333";
const darkGrey2 = "#1A1A1A";
const blueColor1 = "#25417C";
const orangeColor1 = "#EF561E";
const greenColor1 = "#328175";
const greenColor2 = "#339b8f";
const redColor1 = "#D32F2F";
const lightRed1 = "rgb(253, 237, 237)";
const darkRed1 = "rgb(95, 33, 32)";
const successColor = "#2E7D32";
const pinkColor = "#ED5656";
const lightRedColor = "#DD2C2C";
const lightGreenColor = "#1EAF64";
const brownColor = "#995E00";
const violet = "#441A9D";
const lightViolet = "#7c5fbb";
const lightViolet_100 = "#e9e2f6";
const superLightBlue = "#F9FAFD";

const blue = {
  100: "#F2F4FA"
};

const grey = {
  100: "#E5E5E5",
  200: "#F6F6F6",
  250: "#D6D6D6",
  300: "#ADADAD",
  400: "#CFCFCF",
  500: "#8A8A8A",
  550: "#8C8C8C",
  600: "#696969",
  900: "#333333"
};

const red = {
  50: "#FFF4F4",
  100: "#FBE7E7",
  800: "#C80000",
  900: "#862300"
};

const green = {
  100: "#E0F3EB",
  500: "#009849",
  800: "#017A3B"
};

const yellow = {
  100: "#FDF6DA",
  200: "#FFF2C2",
  500: "#E7B810",
  600: "#CFA616",
  800: "#995E00"
};

const snackbar = {
  success: {
    200: "#dbf4eb",
    500: "#007D32"
  },
  error: {
    200: "#ffe6e7",
    500: "#DA0000"
  },
  warning: {
    200: "#fceed9",
    500: "#ff9800"
  },
  info: {
    200: "#dbefff",
    500: "#2196f3"
  }
};

const totalEntrantsChart = {
  tradeVisitor: "#1eaf64",
  hostedBuyer: "#00d9ff",
  vipOrBuyersProg: "#7850ce",
  speaker: "#e7b810",
  contractor: "#b63000",
  pressOrMedia: "#7c4c00",
  conferenceDelegate: "#246cff",
  exhibitingDelegate: "#dd2c2c",
  studentOrLecturer: "#ff9696",
  public: "#696969",
  staff: "#6ecc00"
};

const colors = {
  grey,
  blue,
  red,
  brownColor,
  green,
  yellow,
  lightGreenColor,
  lightRedColor,
  pinkColor,
  primary,
  black,
  white,
  lightGrey1,
  lightGrey2,
  lightGrey3,
  lightGrey4,
  lightGrey5,
  lightGrey6,
  lightGrey7,
  lightGrey8,
  lightGrey9,
  lightGrey10,
  lightGrey11,
  lightGrey12,
  darkGrey1,
  darkGrey2,
  blueColor1,
  orangeColor1,
  greenColor1,
  greenColor2,
  redColor1,
  lightRed1,
  darkRed1,
  successColor,
  violet,
  lightViolet,
  lightViolet_100,
  superLightBlue,
  snackbar,
  totalEntrantsChart
};

export default colors;
